import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { APP_NAVIGATION_ROUTES } from "../../router/router.constants";

const ExternalLeadsList = Loadable(
  lazy(() =>
    import("./ExternalLeadsList").then(({ ExternalLeadsList }) => ({
      default: ExternalLeadsList,
    }))
  )
);

const ManageExternalLead = Loadable(
  lazy(() =>
    import("./ManageExternalLead").then(({ ManageExternalLead }) => ({
      default: ManageExternalLead,
    }))
  )
);

export const externalLeadsRoutes = [
  {
    path: APP_NAVIGATION_ROUTES.externalLeads,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[]} allowFullAccess>
        <ExternalLeadsList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_NAVIGATION_ROUTES.externalLeads}/manage`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[]} allowFullAccess>
        <ManageExternalLead />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_NAVIGATION_ROUTES.externalLeads}/manage/:uuid`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[]} allowFullAccess>
        <ManageExternalLead />
      </AuthorizedRoute>
    ),
  },
];
